<template>
    <div>
        <div class="acitve-items" >
							<div class="active-items-title-read">
								<div class="active-item-title">{{row.title}}</div>
								<div class="active-item-desc">{{row.desc}}</div>
								<div class="active-itme-read">
									<span v-for="(cate,i) in row.cate_list" :key="i">{{cate.name}}</span>
									<span>{{row.views_count}}阅读</span></div>
							</div>
							<div class="active-item-pics">
								<img :src="row.pics_url[0]" alt="">
							</div>
						</div>
    </div>
</template>

<style scoped>
    /* 小图 */
	.acitve-items{width: 6.7rem;background: #fff;border-radius: 10px;padding: 10px;margin: 10px auto;display: flex;justify-content: space-between;}
	.active-items-title-read{display: flex;justify-content: space-between;flex-direction: column;width: 58%;}
.active-item-title{
		 
font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(0,0,0,1); 
	}
	.active-item-pics{width: 40%;}
	.active-item-pics img{width: 100%;height: 1.4rem;}
	.acitve-item-title{
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;
	}
	.active-itme-read{ 
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1); 
	}
	.active-item-desc{
		color: #999;
		font-size: 12px;
	}
    
</style>

<script>
    export default {
        name: "NewsItem2",
        components: {
        },
        props: {

			row: {
				type: Object,
				default: {
					title:'',
					cate_list:[],
					pics:[],
					pics_url:[]
				}
			}

        },

        data: function () {
            return {}
        },

        methods: {
            
        },

        filters: {}

    };
</script>




// WEBPACK FOOTER //
// NewsItem2.vue?186dcb76